// src/components/Users.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./ekyc.module.scss";
import { APIConstant } from "services/api-constant";
import {Select, MenuItem } from "@mui/material";


const UserManagement = ({ token }) => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: "", password: "", role: "candidate" });

  const fetchUsers = async () => {
    const res = await axios.get(APIConstant.users, {
    // const res = await axios.get("http://74.225.150.213:8010/users/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    setUsers(res.data);
  };

  const handleCreate = async () => {
     form.id = 1;
     console.log(form)
    await axios.post(APIConstant.users, form, {
    // await axios.post("http://74.225.150.213:8010/users/", form, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setForm({ username: "", password: "", role: "candidate" });
    fetchUsers();
  };

  const handlePromote = async (id, newRole) => {
    await axios.patch(`${APIConstant.users}/${id}/role/`, { role: newRole }, {
    // await axios.patch(`http://74.225.150.213:8010/users/${id}/role/`, { role: newRole }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchUsers();
  };

  const handleToggleBlock = async (id, blocked) => {
    await axios.patch(`${APIConstant.users}/${id}/block/`, { blocked: !blocked }, {
    // await axios.patch(`http://74.225.150.213:8010/users/${id}/block/`, { blocked: !blocked }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchUsers();
  };

  const handleDelete = async (id) => {
    await axios.delete(`${APIConstant.users}/${id}`, {
    // await axios.delete(`http://74.225.150.213:8010/users/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchUsers();
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className={styles.usersWrapper}>
      <div className={styles.pageHeader}><h2>User Management</h2></div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        padding: '10px 15px',
        marginTop: '10px'
      }}>Create New Users</h3>
      <div className={`${styles.grid} grid-cols-3 gap-3 mb-6`} style={{ marginRight: '15px', marginLeft: '15px', marginTop: '10px' }}>
        <div className="formContainer">
          <label>Username</label>
          <input
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            className="border p-2"
          />
        </div>
        <div className="formContainer">
          <label>Password</label>
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="border p-2"
          />
        </div>
        <div className="formContainer">
          <label>Select Role</label>
        <Select
          labelId="role-label"
          value={form.role}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
           displayEmpty
             sx={{
            borderRadius: "4px",
            padding: "4px 8px",
            height: "35px",
            minWidth: 320,
            "& .MuiSelect-select": {
              padding: "6px 8px", 
            },
              "@media screen and (max-width:600px)": {
              minWidth: "100%", // force full width in mobile
            },
          }}
        >
          <MenuItem value="candidate">Candidate</MenuItem>
          <MenuItem value="interviewer">Interviewer</MenuItem>
          <MenuItem value="admin">Admin</MenuItem>
          
        </Select> 
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'flex-end'
        }}>
        <button
          onClick={handleCreate}
          className="col-span-3 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Create
        </button>
        </div>
      </div>

      <div className={`${styles.tableContainer} space-y-2`}>
        {/* {users.map((user) => (
          <div key={user.id} className="p-4 border rounded flex justify-between items-center">
            <div>
              <p className="font-medium text-gray-800">{user.username}</p>
              <p className="text-sm text-gray-600">
                Role: <strong>{user.role}</strong> | Status:{" "}
                <span className={user.blocked ? "text-red-500" : "text-green-600"}>
                  {user.blocked ? "Blocked" : "Active"}
                </span>
              </p>
            </div>
            <div className="flex gap-2">
              {user.role !== "admin" && (
                <>
                  <button
                    onClick={() => handlePromote(user.id, "admin")}
                    className="px-2 py-1 bg-blue-500 text-white rounded"
                  >
                    Promote to Admin
                  </button>
                  <button
                    onClick={() => handlePromote(user.id, "interviewer")}
                    className="px-2 py-1 bg-purple-500 text-white rounded"
                  >
                    Promote to Interviewer
                  </button>
                </>
              )}
              <button
                onClick={() => handleToggleBlock(user.id, user.blocked)}
                className={`px-2 py-1 ${user.blocked ? "bg-green-500" : "bg-yellow-500"} text-white rounded`}
              >
                {user.blocked ? "Unblock" : "Block"}
              </button>
              <button
                onClick={() => handleDelete(user.id)}
                className="px-2 py-1 bg-red-500 text-white rounded"
              >
                Delete
              </button>
            </div>
          </div>
        ))} */}



          <table className={styles.userListTable}>
            <thead>
              <tr>
                <th width={200}>User Name</th>
                <th width={150}>Role</th>
                <th width={100}>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            {users.map((user) => (
              <tr>
                <td>{user.username}</td>
                <td>{user.role}</td>
                <td>{user.blocked ? "Blocked" : "Active"}</td>
                <td>
                {user.role !== "admin" && (
                <>
                  <button
                    onClick={() => handlePromote(user.id, "admin")}
                    className="px-2 py-1 bg-blue-500 text-white rounded"
                  >
                    Promote to Admin
                  </button>
                  <button
                    onClick={() => handlePromote(user.id, "interviewer")}
                    className="px-2 py-1 bg-purple-500 text-white rounded"
                  >
                    Promote to Interviewer
                  </button>
                </>
              )}
              <a
                onClick={() => handleToggleBlock(user.id, user.blocked)}
                   title="block"
                style={{ fontSize: '12px', textDecoration: 'none', marginLeft: '4px' }}
                className={`px-2 mt-2 py-1 ${user.blocked ? "bg-green-500" : "bg-yellow-500"} text-white rounded`}
              >
                {user.blocked ? "Unblock" : "Block"}
              </a>
              <a 
                onClick={() => handleDelete(user.id)}
                style={{ fontSize: '12px', textDecoration: 'none', marginLeft: '4px' }}
                className="px-2 py-1 mt-2 bg-red-500 text-white rounded"
                title="delete"
              >
                Delete
              </a>
                </td>
              </tr>
               ))}
            </tbody>
            
            
          </table>
        

      </div>
    </div>
  );
};

export default UserManagement;
